import React from 'react'
import styles from './style'
import propTypes from './prop'
import translator from 'src/translate'
import { Grid, withStyles, Box } from '@material-ui/core'
import QuestionCreateLink from '../create-link'
import { componentBoxShowAction } from 'src/reducers/component-box/action'
import { QuestionFieldNames } from 'src/model/card'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import { ButtonData, ButtonType, ButtonActionType } from 'src/model/button'
import { cardLinkDeleteAction } from 'src/reducers/card/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import { componentBoxHideAction } from 'src/reducers/component-box/action'
import ComponentBoxContent from 'src/model/component-box'
import { guid } from 'src/utils/guid'
import ModalContent from 'src/components/card-suneditor/components/link-settings'
import { useCourseSettings } from 'src/hooks/useCourseSettings'
//import { IconPickerItem } from 'react-fa-icon-picker'
import rgbaParser from 'src/utils/rgbaParser'
import {
  CoreButtonGroup,
  CoreButton,
  CoreIconButton,
} from 'src/components/core'
import URLs from 'src/api/url'
import { Icon } from '@iconify/react'
import { useSelector } from 'react-redux'
const SETTING_KEY = 'theme'
const Link = props => {
  const { classes, dispatch, location, refresh } = props
  const { execute, update, exists, value } = useCourseSettings(SETTING_KEY)
  const entity = useSelector(state => state.card.currentCard)
  /**
   *
   */
  const editClickHandler = link => {
    const component = (
      <QuestionCreateLink
        cardId={entity[QuestionFieldNames.ID]}
        location={location}
        refresh={refresh}
        linkId={link?.id}
        deleteButtonClickHandler={deleteButtonClickHandler}
      />
    )
    dispatch(
      componentBoxShowAction(
        new ComponentBoxContent(component, {
          hideCloseButton: false,
        }),
      ),
    )
  }
  const deleteButtonClickHandler = e => {
    const id = e.id
    const question = e.cardId

    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              translator._('action.no'),
              ButtonActionType.NO,
              e => {
                dispatch(messageBoxHideAction())
              },
            ),
            new ButtonData(
              ButtonType.ACTION,
              translator._('action.yes'),
              ButtonActionType.DELETE,
              e => {
                dispatch(messageBoxHideAction())

                dispatch(
                  cardLinkDeleteAction(id, question, () => {}),
                  dispatch(componentBoxHideAction()),
                )
              },
            ),
          ],
          title: translator._('message.delete'),
        }),
      ),
    )
  }
  /**
   *
   * @param {*} e
   */
  const linkButtonClickHandler = e => {
    if (e.currentTarget.dataset.type === 'course') {
      window.open(URLs.APP_URL + e.currentTarget.dataset.url + '_blank')
    } else if (e.currentTarget.dataset.type === 'pdf') {
      window.open(URLs.CDN + e.currentTarget.dataset.url, '_blank')
    } else {
      window.open(e.currentTarget.dataset.url, '_blank')
    }
  }
  const settingsModalClickHandler = () => {
    dispatch(
      componentBoxShowAction(
        new ComponentBoxContent(
          (
            <ModalContent
              classes={classes}
              themeSettings={value}
              cardId={entity[QuestionFieldNames.ID]}
              key={guid.uid}
            />
          ),
          {
            hideCloseButton: false,
            header: translator._('taskItem.linkSettings'),
            backgroundColor:
              value?.bodyBackgroundImage === undefined ||
              value?.bodyBackgroundImage === ''
                ? value?.backgroundColor
                  ? rgbaParser(value?.backgroundColor)
                  : '#ffffff'
                : value?.bodyBackgroundImage,
            fontColor: value?.fontColor
              ? rgbaParser(value?.fontColor)
              : '#000000',
            callback: e => {},
          },
        ),
      ),
    )
  }

  /**
   *
   */
  const LinkItems = () => {
    let links = entity[QuestionFieldNames.QUESTION_LINKS]

    links.sort((a, b) => {
      if (a.id < b.id) return -1
      if (a.id > b.id) return 1
      return 0
    })
    let item = links.map(link => {
      return (
        <Box className={classes.linkBox}>
          <CoreButtonGroup variant="outlined" size="small" fullWidth>
            <CoreButton
              data-url={link.url}
              data-type={link.type}
              onClick={linkButtonClickHandler}
              size="large"
              fullWidth
              truncate={true}
            >
              {link.title}
            </CoreButton>
            <CoreIconButton
              size="small"
              onClick={() => editClickHandler(link)}
              style={{
                width: '40px',
              }}
            >
              <Icon icon="fluent:edit-24-filled" />
            </CoreIconButton>
          </CoreButtonGroup>
        </Box>
      )
    })

    return item
  }

  return entity[QuestionFieldNames.QUESTION_LINKS]?.length > 0 ? (
    <Grid container justifyContent="center" className={classes.gridContainer}>
      <Grid item className={classes.grid}>
        {LinkItems()}

        <CoreIconButton
          onClick={settingsModalClickHandler}
          size="medium"
          variant="text"
          color="dark"
          className={classes.editIcon}
        >
          <Icon icon="fluent:settings-24-filled" />
        </CoreIconButton>
      </Grid>
    </Grid>
  ) : (
    <></>
  )
}

Link.propTypes = propTypes

export default withStyles(styles)(Link)
